// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.baloa-play-menu {
    height: 130vh;
    width: 456px;
    position: absolute;
    background: var(--white-color);
    position: fixed;
}

.baloa-play-menu.hide-menu {
    display: none;
}

.baloa-play-menu__title{
    margin-bottom: 24px;
}

.baloa-play-menu__title__text.baloa-headline-2{
    color: var(--primary-very-dark-color);
}

.baloa-play-menu__field {
    display: flex;
    align-items: center;
    cursor: pointer;
    border-radius: var(--space-quarter);
    padding: 10px;
    margin-bottom: 12px;
}

.baloa-play-menu__field__data__text.baloa-normal-medium{
    color: var(--primary-dark-color);
    display: flex;
    align-items: center;
    line-height: normal;
}
.baloa-play-menu__field:hover, .baloa-play-menu__field:hover .baloa-play-menu__field__data__text.baloa-normal-medium {
    background-color: var(--new-green-color);
    color: var(--white-color);
}
.baloa-play-menu__field.active, .baloa-play-menu__field.active .baloa-play-menu__field__data__text.baloa-normal-medium {
    background-color: var(--new-green-color);
    color: var(--white-color);
}

.baloa-play-menu__field__data {    
    display: flex;    
    align-items: center;
}

.baloa-play-menu__field__data__text span {
    font-size: var(--space-and-half);
    margin-right: 10px;
}

.baloa-play-menu__field__data__text .hubicon-video_library::before {
    color: var(--white-color);
}

.baloa-play-menu__field:hover .hubicon-video_library1::before {
    color: var(--white-color);
}

.baloa-play-menu__following-tournaments {
    margin: 0 var(--space);
    padding-top: var(--space);
    border-top: 1px solid var(--new-gray-background-color);
    border-bottom: 1px solid var(--new-gray-background-color);
}

.baloa-play-menu__following-tournaments__title.baloa-names {
    color: var(--basic-gray-color);  
    margin-bottom: var(--space); 
}

.baloa-play-menu__menu-links {
    margin: 0 var(--space);
    padding: 18px 0;
}

.baloa-play-menu__following-tournament__img {
    width: 38px;
    height: 38px;
}

.baloa-play-menu__following-tournament__img img {
    width: 38px;
    height: 38px;
    border-radius: 50%;
}

.baloa-play-menu__following-tournament__img .icon-ball {
    font-size: calc(var(--space-and-half) + var(--space-eighth));/*26px*/
    font-weight: var(--font-bold);
    border-radius: 50%;
    padding: 6px;
    height: calc(var(--space-and-half) + var(--space-eighth) + calc(6px * 2));
    color: var(--white-color);
}

.baloa-play-menu__following-tournament__tournament-name.baloa-names {
    color: var(--primary-dark-color);
    margin-bottom: var(--space-half);
}

.baloa-play-menu__following-tournament__tournament-info__label.baloa-username {
    padding: var(--space-eighth) calc(var(--space-half) - 2px);
    background-color: var(--new-grey-light-background-color);
    border: 1px solid var(--new-grey-border-color);
    border-radius: var(--space-and-half);
    color: var(--primary-dark-color);
    font-size: var(--space-half-quarter);
}

.baloa-play-menu__following-tournament__tournament-info__label:nth-of-type(2) {
    margin: 0 var(--space-quarter);
}

.baloa-play-menu__following-tournament__container {
    margin-bottom: var(--space);
}

.baloa-play-menu__following-tournament__container,
.baloa-play-menu__following-tournament__tournament-info__labels {
    display: flex;
    align-items: center;
}

.baloa-play-menu__following-tournament__tournament-info {
    margin-left: var(--space-half);
}

.baloa-table-column.baloa-play-menu__following-tournament__view-more {
    color: var(--new-green-color);
    margin-bottom: var(--space);
    cursor: pointer;
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    
    .baloa-play-menu__container {
        display: none;     
    }
}


`, "",{"version":3,"sources":["webpack://./src/shared/components/baloa-play-menu/BaloaPlayMenuComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,mCAAmC;IACnC,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,wCAAwC;IACxC,yBAAyB;AAC7B;AACA;IACI,wCAAwC;IACxC,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,sDAAsD;IACtD,yDAAyD;AAC7D;;AAEA;IACI,8BAA8B;IAC9B,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,4DAA4D,CAAC,OAAO;IACpE,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,yEAAyE;IACzE,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;IAChC,gCAAgC;AACpC;;AAEA;IACI,0DAA0D;IAC1D,wDAAwD;IACxD,8CAA8C;IAC9C,oCAAoC;IACpC,gCAAgC;IAChC,oCAAoC;AACxC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;;IAEI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;IAC7B,2BAA2B;IAC3B,eAAe;AACnB;;AAEA,yCAAyC,4BAA4B;;IAEjE;QACI,aAAa;IACjB;AACJ","sourcesContent":[".baloa-play-menu {\n    height: 130vh;\n    width: 456px;\n    position: absolute;\n    background: var(--white-color);\n    position: fixed;\n}\n\n.baloa-play-menu.hide-menu {\n    display: none;\n}\n\n.baloa-play-menu__title{\n    margin-bottom: 24px;\n}\n\n.baloa-play-menu__title__text.baloa-headline-2{\n    color: var(--primary-very-dark-color);\n}\n\n.baloa-play-menu__field {\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    border-radius: var(--space-quarter);\n    padding: 10px;\n    margin-bottom: 12px;\n}\n\n.baloa-play-menu__field__data__text.baloa-normal-medium{\n    color: var(--primary-dark-color);\n    display: flex;\n    align-items: center;\n    line-height: normal;\n}\n.baloa-play-menu__field:hover, .baloa-play-menu__field:hover .baloa-play-menu__field__data__text.baloa-normal-medium {\n    background-color: var(--new-green-color);\n    color: var(--white-color);\n}\n.baloa-play-menu__field.active, .baloa-play-menu__field.active .baloa-play-menu__field__data__text.baloa-normal-medium {\n    background-color: var(--new-green-color);\n    color: var(--white-color);\n}\n\n.baloa-play-menu__field__data {    \n    display: flex;    \n    align-items: center;\n}\n\n.baloa-play-menu__field__data__text span {\n    font-size: var(--space-and-half);\n    margin-right: 10px;\n}\n\n.baloa-play-menu__field__data__text .hubicon-video_library::before {\n    color: var(--white-color);\n}\n\n.baloa-play-menu__field:hover .hubicon-video_library1::before {\n    color: var(--white-color);\n}\n\n.baloa-play-menu__following-tournaments {\n    margin: 0 var(--space);\n    padding-top: var(--space);\n    border-top: 1px solid var(--new-gray-background-color);\n    border-bottom: 1px solid var(--new-gray-background-color);\n}\n\n.baloa-play-menu__following-tournaments__title.baloa-names {\n    color: var(--basic-gray-color);  \n    margin-bottom: var(--space); \n}\n\n.baloa-play-menu__menu-links {\n    margin: 0 var(--space);\n    padding: 18px 0;\n}\n\n.baloa-play-menu__following-tournament__img {\n    width: 38px;\n    height: 38px;\n}\n\n.baloa-play-menu__following-tournament__img img {\n    width: 38px;\n    height: 38px;\n    border-radius: 50%;\n}\n\n.baloa-play-menu__following-tournament__img .icon-ball {\n    font-size: calc(var(--space-and-half) + var(--space-eighth));/*26px*/\n    font-weight: var(--font-bold);\n    border-radius: 50%;\n    padding: 6px;\n    height: calc(var(--space-and-half) + var(--space-eighth) + calc(6px * 2));\n    color: var(--white-color);\n}\n\n.baloa-play-menu__following-tournament__tournament-name.baloa-names {\n    color: var(--primary-dark-color);\n    margin-bottom: var(--space-half);\n}\n\n.baloa-play-menu__following-tournament__tournament-info__label.baloa-username {\n    padding: var(--space-eighth) calc(var(--space-half) - 2px);\n    background-color: var(--new-grey-light-background-color);\n    border: 1px solid var(--new-grey-border-color);\n    border-radius: var(--space-and-half);\n    color: var(--primary-dark-color);\n    font-size: var(--space-half-quarter);\n}\n\n.baloa-play-menu__following-tournament__tournament-info__label:nth-of-type(2) {\n    margin: 0 var(--space-quarter);\n}\n\n.baloa-play-menu__following-tournament__container {\n    margin-bottom: var(--space);\n}\n\n.baloa-play-menu__following-tournament__container,\n.baloa-play-menu__following-tournament__tournament-info__labels {\n    display: flex;\n    align-items: center;\n}\n\n.baloa-play-menu__following-tournament__tournament-info {\n    margin-left: var(--space-half);\n}\n\n.baloa-table-column.baloa-play-menu__following-tournament__view-more {\n    color: var(--new-green-color);\n    margin-bottom: var(--space);\n    cursor: pointer;\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    \n    .baloa-play-menu__container {\n        display: none;     \n    }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
